export const DELAY_UNITS = [
  { value: 'minutes', label: 'minutos', seconds: 60 },
  { value: 'hours', label: 'horas', seconds: 3600 },
  { value: 'days', label: 'dias', seconds: 86400 },
];

export const DELAY_PRESETS = [
  { label: '1 min', value: 1, unit: 'minutes' },
  { label: '5 min', value: 5, unit: 'minutes' },
  { label: '20 min', value: 20, unit: 'minutes' },
  { label: '2 h', value: 2, unit: 'hours' },
  { label: '1 dia', value: 1, unit: 'days' },
];

export const DEFAULT_RETRY_RULES = [
  { disposition: 'busy', retryDelaySeconds: 1200, maxAttempts: 3 },
  { disposition: 'noanswer', retryDelaySeconds: 7200, maxAttempts: 3 },
  { disposition: 'congestion', retryDelaySeconds: 1800, maxAttempts: 2 },
  { disposition: 'failed', retryDelaySeconds: 3600, maxAttempts: 2 },
  { disposition: 'abandon', retryDelaySeconds: 259200, maxAttempts: 1 },
];

export const RETRY_DISPOSITION_LABELS = {
  busy: 'Ocupado',
  noanswer: 'Não atendeu',
  congestion: 'Congestionamento',
  failed: 'Falha',
  abandon: 'Abandono na fila',
  answering_machine: 'Secretária eletrônica',
};

const UNIT_SECONDS = {
  minutes: 60,
  hours: 3600,
  days: 86400,
};

export function secondsToDelayParts(seconds) {
  const total = Math.round(Number(seconds) || 0);
  if (total >= 86400 && total % 86400 === 0) {
    return { value: total / 86400, unit: 'days' };
  }
  if (total >= 3600 && total % 3600 === 0) {
    return { value: total / 3600, unit: 'hours' };
  }
  if (total > 0 && total % 60 === 0) {
    return { value: total / 60, unit: 'minutes' };
  }
  if (total > 0) {
    return { value: total / 60, unit: 'minutes' };
  }
  return { value: 1, unit: 'minutes' };
}

export function delayPartsToSeconds(value, unit) {
  const amount = Number(value);
  const factor = UNIT_SECONDS[unit] || UNIT_SECONDS.minutes;
  if (!Number.isFinite(amount) || amount <= 0) {
    return 60;
  }
  return Math.max(60, Math.round(amount * factor));
}

export function formatHumanDelay(seconds) {
  const parts = secondsToDelayParts(seconds);
  const n = parts.value;
  if (parts.unit === 'days') {
    return n === 1 ? '1 dia' : `${n} dias`;
  }
  if (parts.unit === 'hours') {
    return n === 1 ? '1 hora' : `${n} horas`;
  }
  return n === 1 ? '1 minuto' : `${n} minutos`;
}

export function rulesToUi(rules) {
  const source = Array.isArray(rules) && rules.length > 0 ? rules : DEFAULT_RETRY_RULES;
  return source.map((rule) => {
    const parts = secondsToDelayParts(rule.retryDelaySeconds);
    return {
      disposition: rule.disposition,
      maxAttempts: rule.maxAttempts,
      delayValue: parts.value,
      delayUnit: parts.unit,
    };
  });
}

export function uiRulesToPayload(rules) {
  return (Array.isArray(rules) ? rules : []).map((rule) => ({
    disposition: rule.disposition,
    retryDelaySeconds: delayPartsToSeconds(rule.delayValue, rule.delayUnit),
    maxAttempts: Math.max(1, Number(rule.maxAttempts) || 1),
  }));
}
